import http from "../../backend/http.js";

async function getUnit(id) {
  try {
    const response = await http.get(`sales/units/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      code: response.data.code,
    };
  } catch (err) {
    throw err;
  }
}

async function updateUnit(id, data) {
  try {
    const response = await http.put(`sales/units/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createUnit(data) {
  try {
    const response = await http.post("sales/units", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getUnits(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `sales/units?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getUnit, updateUnit, getUnits, createUnit };